<div *ngIf="!isMerchant()" class="menu-wrapper" [ngClass]="{'layout-sidebar-active': app.sidebarActive}" (click)="app.onSidebarClick()"
    (mouseleave)="app.onSidebarMouseLeave()"
    data-testid="admin-sidebar">
    <div class="sidebar-logo" [ngClass]="{'logo-centered': !app.sidebarActive}">
        <ng-container *ngIf="!app.sidebarActive">
            <a [routerLink]="['/']">
                <img class="x-logo" src="../XpressApp/assets/layout/images/menu/icon_x.png" />
            </a>
        </ng-container>
        <ng-container *ngIf="app.sidebarActive">
            <a [routerLink]="['/']">
                <img class="xpress-logo" src="../XpressApp/assets/layout/images/menu/xpress_logo.svg" />
            </a>
        </ng-container>
        <a href="#" class="sidebar-pin" (click)="app.onToggleMenu($event)">
            <span class="pin" [ngClass]="{'pin-active': app.sidebarStatic}"></span>
        </a>
    </div>

    <div class="geoZonesDropdown" [ngClass]="{'non-visible': !app.sidebarActive}" data-testid="location-selector">
        <!--<p-dropdown [options]="geoZones"
                [optionLabel]="'Name'"
                (ngModelChange)="onGeoZoneChanged($event)"
                [(ngModel)]="selectGeoZone"
                [style]="{width: '100%', background: '#FFF', height: '38px', marginLeft: '6%'}"></p-dropdown>-->
        <p-dropdown [options]="xpressClientLocationTypeList" optionLabel="name" optionValue="id"
            [(ngModel)]="selectClientLocationType" (ngModelChange)="onClientLocationTypChanged($event)"
            [style]="{width: '100%', background: '#FFF', height: '38px', marginLeft: '6%'}">
        </p-dropdown>
    </div>

    <div class="layout-menu-container">
        <ul class="layout-menu">
            <li class="location-item" [ngClass]="{'non-visible': app.sidebarActive}">
                <img class="location-icon" src="\XpressApp\assets\layout\images\menu\icon_location.svg" />
                <div class="location">Location</div>
            </li>
            <li [ngClass]="{'layout-sidebar-active': !app.sidebarActive, 'padding-inactive': app.sidebarActive}"
                app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"
                [attr.data-testid]="navigationMenuTestId(item)"></li>
        </ul>
    </div>
    <div class="build-number">FE version: {{webBuildNumber}}</div>
    <div class="build-number-be">BE version: {{apiBuildNumber}}</div>
</div>

<ng-container *ngIf="isMerchant()">
    <menuitem-partners [menuItems]="model" [profile]="_profile"></menuitem-partners>
</ng-container>
